

































































export default {
  name: 'Devices',
};
